"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _templateObject;

/* istanbul ignore next */
var ErrorHelperText = (0, _styledComponents.default)(_material.Typography)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  min-height: 14px;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: italic;\n  line-height: 1.17;\n  letter-spacing: normal;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.error.main;
});
var _default = ErrorHelperText;
exports.default = _default;